import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/shadcn-ui/button";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-muted flex items-center justify-center py-16">
      <main className="w-full max-w-lg">
        <section className="bg-card rounded-xl shadow-md p-12 md:p-16 text-center">
          <div className="error-card">
            <h1 className="text-8xl md:text-9xl font-bold text-primary m-0 leading-none">404</h1>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground my-4">Page Not Found</h2>
            <p className="text-foreground text-lg mb-8 leading-relaxed">
              The page you're looking for doesn't exist or has been moved.
            </p>

            <div className="flex gap-4 justify-center flex-wrap">
              <Button asChild className="min-w-[120px]">
                <Link to="/">Go Home</Link>
              </Button>
              <Button
                variant="secondary"
                onClick={() => window.history.back()}
                className="min-w-[120px]"
              >
                Go Back
              </Button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default NotFoundPage;
